import * as React from "react";

interface OpusDocumentIllustrationProps {
  className?: string;
  bgClassName?: string;
  accentClassName?: string;
}

const OpusDocumentIllustration: React.FC<OpusDocumentIllustrationProps> = ({
  className,
  bgClassName = "fill-background",
  accentClassName = "fill-gray-1",
}) => {
  return (
    <svg width="74" height="90" viewBox="0 0 74 90" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M0 8.03149C0 3.59582 3.13048 0 6.99213 0H67.0079C70.8695 0 74 3.59582 74 8.0315V81.9685C74 86.4042 70.8695 90 67.0079 90H6.99212C3.13048 90 0 86.4042 0 81.9685V8.03149Z" className={bgClassName} />
<path fillRule="evenodd" clipRule="evenodd" d="M67.0079 3H6.99213C4.57292 3 2.61176 5.25268 2.61176 8.03149V81.9685C2.61176 84.7473 4.57292 87 6.99212 87H67.0079C69.4271 87 71.3882 84.7473 71.3882 81.9685V8.0315C71.3882 5.25268 69.4271 3 67.0079 3ZM6.99213 0C3.13048 0 0 3.59582 0 8.03149V81.9685C0 86.4042 3.13048 90 6.99212 90H67.0079C70.8695 90 74 86.4042 74 81.9685V8.0315C74 3.59582 70.8695 0 67.0079 0H6.99213Z" className={accentClassName}/>
<path d="M30 15C30 13.3431 28.6569 12 27 12H15C13.3431 12 12 13.3431 12 15V27C12 28.6569 13.3431 30 15 30H27C28.6569 30 30 28.6569 30 27V15Z" className={accentClassName}/>
<rect x="12" y="42" width="50" height="6" rx="3" className={accentClassName}/>
<rect x="12" y="54" width="50" height="6" rx="3" className={accentClassName}/>
<rect x="12" y="66" width="26" height="6" rx="3" className={accentClassName}/>
</svg>
  );
};

export default OpusDocumentIllustration;